export default __webpack_public_path__ + "images/small_deepecho_icon_dark.30612cae0abcdfcbc90b49e962d1bec9.png";